<template>
  <div
    :class="{'notifications-slider--slider': !isSingle }"
    class="notifications-slider">
    <transition
      :name="transitionName"
      @after-leave="transitionEndHandler">
      <div
        :key="currentSlideId"
        class="notification-slider__item">
        <div class="notifications-slider__slide">
          <slot v-bind="{ notification: notifications[activeSlide] }" />
        </div>
      </div>
    </transition>

    <button
      class="notifications-slider__button notifications-slider__button--left"
      @click="changeSlide('prev')">
      <arrowhead-icon class="notifications-slider__icon notifications-slider__icon--left" />
    </button>
    <button
      class="notifications-slider__button notifications-slider__button--right"
      @click="changeSlide('next')">
      <arrowhead-icon class="notifications-slider__icon notifications-slider__icon--right" />
    </button>
  </div>
</template>

<script>
import ArrowheadIcon from 'Components/ui/Icons/ArrowheadIcon.vue';

export default {
  name: 'NotificationsSlider',

  components: {
    ArrowheadIcon,
  },

  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeSlide: 0,
      transitionName: 'slide-right',
    };
  },

  computed: {
    isSingle() {
      return this.notifications.length === 1;
    },

    currentSlideId() {
      return this.notifications?.[this.activeSlide]?.id;
    },
  },

  watch: {
    notifications: {
      handler(newValue) {
        if (newValue.length) {
          this.activeSlide = 0;
        }
      },
    },
  },

  methods: {
    changeSlide(direction) {
      if (direction === 'next') {
        this.transitionName = 'slide-right';
        if (this.activeSlide < this.notifications.length - 1) {
          this.activeSlide += 1;
          return;
        }

        this.activeSlide = 0;
        return;
      }

      this.transitionName = 'slide-left';
      if (this.activeSlide === 0) {
        this.activeSlide = this.notifications.length - 1;
        return;
      }

      this.activeSlide -= 1;
    },

    transitionEndHandler() {
      this.transitionName = 'slide-right';
    },
  },
};
</script>

<style lang="scss" scoped>
  .notifications-slider {
    width: 100%;
    position: relative;
    background-color: $color--basic-black;
    border-radius: none;
    transition: transform 0.2s;
  }

  .notifications-slider--slider {
    .notifications-slider__button {
      pointer-events: initial;
      opacity: 1;
    }

    .notifications-slider__button--left,
    .notifications-slider__button--right {
      transform: translateX(0)
    }
  }

  .notifications-slider__slide {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
  }

  .notification-slider__item.slide-left-leave-active .notifications-slider__slide,
  .notification-slider__item.slide-right-leave-active .notifications-slider__slide {
    position: absolute
  }

  .notifications-slider__button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    width: 35px;
    height: 100%;
    padding: 0;
    border: none;
    background-color: transparent;
    outline: none;
    opacity: 0;
    transition-property: opacity, transform;
    transition-duration: var(--transition-opacity-time);
    pointer-events: none;
  }

  .notifications-slider__button--right {
    right: 0;
    transform: translateX(30px);
  }

  .notifications-slider__button--left {
    left: 0;
    transform: translateX(-30px);
  }

  .notifications-slider__icon {
    width: 24px;
    height: 24px;
  }

  .notifications-slider__icon--right {
    transform: rotate(-90deg);
  }

  .notifications-slider__icon--left {
    transform: rotate(90deg);
  }

  .slide-right,
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left,
  .slide-left-enter-active,
  .slide-left-leave-active {
    transition-property: opacity, transform;
    transition-duration: 0.5s;
  }

  .slide-right-enter,
  .slide-left-leave-to {
    transform: translateX(-100%);
  }

  .slide-right-leave-to,
  .slide-left-enter {
    transform: translateX(100%);
  }

  .slide-right-enter-to,
  .slide-right-leave,
  .slide-left-enter-to,
  .slide-left-leave {
    opacity: 1;
    transform: translateX(0) scale(1);
  }

  @media screen and #{$screen-more-or-1024} {
    .notifications-slider {
      border-radius: 10px;
      width: 260px;
      background-color: transparent;

      &:before,
      &:after {
        content: "";
        display: block;
        width: 60%;
        height: 70px;
        background-color: #2C3D59;
        border-radius: inherit;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: -1;
        opacity: 0;
        transition-property: opacity, transform;
        transition-duration: var(--transition-opacity-time);
      }

      &:after {
        right: 0;
      }

      &:before {
        left: 0;
      }
    }

    .notifications-slider--slider {
      &:before {
        opacity: 1;
        transform: translate(-12px, -50%);
      }

      &:after {
        opacity: 1;
        transform: translate(12px, -50%);
      }
    }

    .slide-right-enter,
    .slide-left-leave-to {
      opacity: 0;
      transform: scale(0.85) translateX(-15%);
    }

    .slide-right-leave-to,
    .slide-left-enter {
      opacity: 0;
      transform: scale(0.85) translateX(15%);
    }
  }
</style>
